import { useEffect } from "react";
import { createFieldAnchor } from "web_myplann/Shared/Utils/createFieldAnchor";
import { holdFieldAtAnchor } from "web_myplann/Shared/Utils/holdFieldAtAnchor";
import { isAndroidApp } from "web_myplann/Utils/device";

export const useAndroidKeyboardFieldReveal = () => {
	useEffect(() => {
		if (!isAndroidApp) {
			return;
		}

		const handleResize = () => {
			const anchor = createFieldAnchor(window.innerHeight);
			if (anchor) {
				holdFieldAtAnchor(anchor);
			}
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);
};
